import { Flex, Text } from '@chakra-ui/react';
import React from 'react';

import { Badge } from 'toolkit/chakra/badge';

interface Props {
  label: string;
}

const SettingsComingSoon = ({ label }: Props) => {
  return (
    <Flex mt={ 4 } alignItems="center" justifyContent="space-between" opacity={ 0.6 }>
      <Text>{ label }</Text>
      <Badge size="sm" colorPalette="gray" variant="subtle">Coming soon</Badge>
    </Flex>
  );
};

export default React.memo(SettingsComingSoon);
